// 过滤掉一些效果不太好的模版，todo: 这期在前端加，后续看看能不能在模版商城打个标
export const IGNORE_TEMPLATE = {
    32024: true,
    31241: true,
    31655: true,
    30252: true,
    30400: true,
    60096: true,
    30672: true,
    30247: true,
    31658: true,
    30567: true,
    30568: true,
    30576: true,
    30573: true,
    30570: true,
    30574: true,
    30397: true,
    30401: true,
    30402: true,
    60092: true,
    xwkjuknn3bbxdj3wnoekn5pq6r: true,
    eeqpucgpajgc5xk4tr8jutbsuy: true,
    x7myhyix7tfefmor84c5exdwpy: true,
    '1tr5u58emtycxq199g7tjhf9xh': true,
    c66y1zrzgpg67yormm9odisiue: true,
    y3w37hfhwt8gznzmuq3jogi4ha: true,
    cizyx9o5e3b1jeeio81omfag9w: true,
    kpoxwtowd7f5ieqzxqyshot8jy: true,
    u5egs6auyjyoi85qd3zesqifpr: true,
    wyfqwpycnp8kxbhyi81a1xpese: true,
    pd6r7ehnm7rmbdg8dq7zfkps8c: true,
    qxcp6hze67nh8d5cd5spy5zszc: true,
    co5y6cc6yfb5pf1hrri99qe4ha: true,
    '6c77u1ypyigoubpeuc1cemi3xh': true,
    ridu5wsojtdhpfrmq7tttqjhmc: true,
    egwrjmkbdp89zri966u1ohmthw: true,
    '9hu99pfumbfru8795o39pkknmr': true,
};
